export * from "./DeilgateCards";
